import React, { ReactNode } from 'react';

import './dashboard.scss';

interface DashboardProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  className?: string;
}

const Dashboard: React.FC<DashboardProps> = ({
  title,
  subtitle,
  children,
  className = '',
}) => {
  return (
    <div className={`dashboard ${className}`}>
      <div className="header">
        <h1 className="dashboard-title">{title}</h1>
        <h2 className="dashboard-subtitle">{subtitle}</h2>
      </div>
      <div className="dashboard-content">{children}</div>
    </div>
  );
};

export default Dashboard;
